// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import bus from 'vue-bus'

import echarts from 'echarts' //引入echarts

Vue.prototype.$echarts = echarts //引入组
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.use(bus);

router.beforeEach((to, from,next)=>{
  //路由拦截，如果是去我的页面先判断有没有登录
  let cookieKey = document.cookie.indexOf('SESSIONIDND=');
  if(to.path=='/mySite'){
    if(cookieKey==-1){
      //未登录
      router.push({path:from.path})
    }else{
      //已登录则直接跳转
      next();
      // if(from.path=='/scanReport'){
      //   to.meta.keepAlive = true;
      //   next();
      // }else{
      //   to.meta.keepAlive = false;
      //   next();
      // }
    }
  }else{
    next();
  }
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js